import React, {useContext, useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {AppContext} from "../../context/AppContext";
import {motion, useReducedMotion} from "framer-motion";
import {invoicesVariants} from "../../utilities/framerVariants";
import {getUsers} from "../../store/actions/userActions";
import styles from "./Users.module.scss";
import Button from "../elements/Button/Button";
import clsx from "clsx";
import List from "./components/List/List";
import {useNavigate} from "react-router-dom";
import usersLengthMessage from "../../utilities/usersLengthMessage";

const Users = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {users} = useSelector((state) => state.user);
    const {windowWidth, isAdmin} = useContext(AppContext);
    const isDesktop = windowWidth >= 768;
    const shouldReduceMotion = useReducedMotion();
    const variant = (element) => {
        return shouldReduceMotion
            ? invoicesVariants.reduced
            : invoicesVariants[element];
    };

    const handleCreateUser = () => {
        navigate('/register');
    }

    useEffect(() => {
        dispatch(getUsers());
        if (users) {
            document.title = `Users (${users.length})`;
        }
    }, []);

    return (
        <section className={styles.section}>
            <motion.div
                className={styles.header}
                variants={variant('header')}
                initial="hidden"
                animate="visible"
                exit="exit"
            >
                <div>
                    <h2 className={styles.heading}>Users</h2>
                    <p>{usersLengthMessage(users, windowWidth)}</p>
                </div>
                {isAdmin && (
                    <Button className={clsx('primary', styles.invoiceButton)} type="button" onClick={handleCreateUser}>
                        New {isDesktop && 'User'}
                    </Button>
                )}
            </motion.div>
            <List/>
        </section>
    );
};

export default Users;
